import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";
import { addCourse } from "./addCourse";

let isEditing = false;
const originalValues = [];
let courseId = 0;

function init() {
    courseId = $("#courseId").val();
    setEvents();
    builderOriginalFormValues();
    getCourseGrantIncomeList("grantIncomeWrapper");
    getCourseMiscellaneousIncomeList("miscellaneousIncomeWrapper");
    getCourseFeesList("courseFeesWrapper");
}

function setEvents() {
    $("#financialsPartial").on("click", ".btnFinancialsInfoEdit", toggleEditFinancialInfo);
    $("#financialsPartial").on("click", ".btnCancelFinancialEdit", cancelEdit);

    $("#financialsPartial").on("click", ".btnSaveFinancialEdit", function () {
        const $btn = $(this);
        $btn.prop("disabled", true);
        const $form = $("#CourseFinancialsForm");

        const params = {
            "contentType": dataaccess.contentType.APPLICATION_X_WWW_FORM_URLENCODED,
            "data": $form.serialize(),
            "url": $form.attr("action")
        };

        dataaccess.post(params).done(function (result) {
            $("#financialsPartial").html(result);
            $btn.prop("disabled", false);
            // Something is messed up with the way the edit button is being toggled which requires a double click to edit after saving.
            // This takes care of the additional click. We need to find a fix for this. We shouldn't be adding/removing Font Awesome classes like this.
            $("#editFinancialsIcon").click();
            $("#CourseFinancialsForm").get(0).reset();
            $("#BtnEditCourseFeesFinancials").click(btnEditCourseFeesClick);
            getCourseGrantIncomeList("grantIncomeWrapper");
            getCourseMiscellaneousIncomeList("miscellaneousIncomeWrapper");
            getCourseFeesList("courseFeesWrapper");
        });
    });

    $("#BtnEditCourseFeesFinancials").click(btnEditCourseFeesClick);
    $("#btnMiscellaneousIncomeAdd").click(btnMiscellaneousIncomeAddClick);
    $("#btnGrantIncomeAdd").click(btnGrantIncomeAddClick);
    $(document).on("click", ".js-grantincome-edit", evtJsGrantIncomeEdit);
    $(document).on("click", ".js-grantincome-delete", evtJsGrantIncomeDelete);
    $(document).on("click", ".js-miscellaneousincome-edit", evtJsMiscellaneousIncomeEdit);
    $(document).on("click", ".js-miscellaneousincome-delete", evtJsMiscellaneousIncomeDelete);
    $(document).on("change", "#chkNoRegistrationFeeCharged", evtChkNoRegistrationFeeChargedChange)
    $(document).on("click", "#btnCourseGrantIncomeUpdateSubmit", evtbtnCourseGrantIncomeUpdateSubmit)

    $(document).on("submit", "#CourseMiscellaneousIncomeEditForm", function (e) {
        e.preventDefault();
        const $form = $(this);

        if ($form.valid()) {
            const $btnSubmit = $("#CourseMiscellaneousIncomeModal button[type=submit]");
            $btnSubmit.prop("disabled", true);

            const params = {
                "contentType": dataaccess.contentType.APPLICATION_X_WWW_FORM_URLENCODED,
                "data": $form.serialize(),
                "url": $form.attr("action"),
                "successMsg": "Miscellaneous Income has been saved."
            };

            dataaccess.post(params).done(function (result) {
                $("#CourseMiscellaneousIncomeModal").modal("hide");
            }).always(function () {
                $btnSubmit.prop("disabled", false);
                getCourseMiscellaneousIncomeList("miscellaneousIncomeWrapper")
            });
        }
    });

    $(document).on("change", "#GrantIncomeInKind", function () {
        toggleGrantIncomeFields();
    });

}

$('#CourseFeesModal').on('hide.bs.modal', function (e) {
    getCourseFeesList("courseFeesWrapper");
})

function initDecimalMask() {
    $(".js-mask-decimal").mask("0999999.99");
}

function evtChkNoRegistrationFeeChargedChange() {
    if ($(this).is(":checked")) {
        $("#txtRegistrationFee").addClass("hidden").val(0);
    } else {
        $("#txtRegistrationFee").removeClass("hidden");
    }
}

function btnEditCourseFeesClick() {
    addCourse.getCourseFees("EditCourseFeesSection", courseId);
    $("#CourseFeesModal").modal("show");
}

function toggleEditFinancialInfo() {
    if (!isEditing) {
        $("#isEditing").val("Y");
        $("#editFinancialsIcon").removeClass("far").addClass("fa");
        $("#CourseMaterialsIncludedChk").removeAttr("disabled");
        $("#CourseFinancialsForm .js-readonly").hide();
        $("#divFinancialCancelSaveBtns, #CourseFinancialsForm .js-edit").removeClass("hidden");
        processNoRegistrationFeeCharged();
    } else {
        $("#isEditing").val("N");
        $("#editFinancialsIcon").removeClass("fa").addClass("far");
        $("#CourseFinancialsForm .js-readonly").show();
        $("#divFinancialCancelSaveBtns, #CourseFinancialsForm .js-edit").addClass("hidden");
        $("#CourseMaterialsIncludedChk").attr("disabled", true);
        resetValues();
    }
    isEditing = !isEditing;
}

function processNoRegistrationFeeCharged() {
    if ($("#chkNoRegistrationFeeCharged").is(":checked")) {
        $("#txtRegistrationFee").addClass("hidden").val(0);
    }
}

//If they edit it and click cancel we need to revert it to the model values so they are being saved here.
function builderOriginalFormValues() {
    $("#CourseFinancialsForm").find(":input:not([type='hidden'])").each(function () {
        originalValues.push({ id: $(this).attr("id"), value: $(this).is(":checkbox") ? $(this).is(":checked") : $(this).val(), type: $(this).attr("type") || $(this)[0].tagName });
    });
}
function cancelEdit() {
    toggleEditFinancialInfo();
}
function resetValues() {
    for (let i = 0; i < originalValues.length; i++) {
        switch (originalValues[i].type.toLowerCase()) {
            case "email":
            case "select":
            case "text":
                $("#" + originalValues[i].id).val(originalValues[i].value);
                break;
            case "checkbox":
                $("#" + originalValues[i].id).prop("checked", originalValues[i].value);
                break;
        }
    }
}

function getCourseFeesList(resultTargetId) {
    dataaccess.get({ url: "/Course/CourseFeesList/" + courseId }).done(function (results) {
        $("#" + resultTargetId).html(results);
        if ($("#isEditing").val() === "Y") {
            $("#" + resultTargetId + " .js-edit").removeClass("hidden");
        }
    });
}

//
//Miscellaneous Income related
//
function btnMiscellaneousIncomeAddClick() {
    courseMiscellaneousIncomeEdit("CourseMiscellaneousIncomeEditSection");
    $("#CourseMiscellaneousIncomeModal").modal("show");
}

function getCourseMiscellaneousIncomeList(resultTargetId) {
    dataaccess.get({ url: "/Course/CourseMiscellaneousIncomeList/" + courseId }).done(function (results) {
        $("#" + resultTargetId).html(results);
        if ($("#isEditing").val() === "Y") {
            $("#" + resultTargetId + " .js-edit").removeClass("hidden");
        }
    });
}

function evtJsMiscellaneousIncomeEdit() {
    const recordId = parseInt($(this).closest("tr").attr("data-miscellaneousincomeid"));
    courseMiscellaneousIncomeEdit(recordId);
}

function evtJsMiscellaneousIncomeDelete() {
    const recordId = parseInt($(this).closest("tr").attr("data-miscellaneousincomeid"));
    const params = {
        data: recordId,
        successMsg: "Miscellaneous Income Item Removed.",
        url: "/Course/CourseMiscellaneousIncomeRemove"
    };
    dataaccess.post(params).done(function (results) {
        getCourseMiscellaneousIncomeList("miscellaneousIncomeWrapper")
    });
}

function courseMiscellaneousIncomeEdit(recordId) {
    dataaccess.get({ url: "/Course/CourseMiscellaneousIncomeEdit/" + recordId }).done(function (results) {
        $("#CourseMiscellaneousIncomeEditSection").html(results);
        $("#tableCourseMiscellaneousIncomeEdit #CourseId").val(courseId);
        initDecimalMask();
        $.validator.unobtrusive.parse($("#CourseMiscellaneousIncomeEditForm"));
        $("#CourseMiscellaneousIncomeModal").modal("show");
    });
}
//
// Grant Income related
//
function btnGrantIncomeAddClick() {
    courseGrantIncomeEdit(0);
}

function getCourseGrantIncomeList(resultTargetId) {
    dataaccess.get({ url: "/Course/CourseGrantIncomeList/" + courseId }).done(function (results) {
        $("#" + resultTargetId).html(results);
        if ($("#isEditing").val() === "Y") {
            $("#" + resultTargetId + " .js-edit").removeClass("hidden");
        }
    });
}

function evtJsGrantIncomeEdit() {
    const recordId = parseInt($(this).closest("tr").attr("data-grantincomeid"));
    courseGrantIncomeEdit(recordId);
}

function courseGrantIncomeEdit(recordId) {
    dataaccess.get({ url: "/Course/CourseGrantIncomeEdit/" + recordId }).done(function (results) {
        $("#EditCourseGrantIncomeSection").html(results);
        $("#tableCourseGrantIncomeEdit #CourseId").val(courseId);
        initDecimalMask();
        $.validator.unobtrusive.parse($("#CourseGrantIncomeEditForm"));
        if ($("#GrantIncomeInKind").is(':checked')) {
            toggleGrantIncomeFields();
        };
        $("#CourseGrantIncomeModal").modal("show");
        
    });
}

function toggleGrantIncomeFields() {
    $("#InKindAmount").toggle();
    $("#InKindTypeDropdown").toggle();
}

function evtJsGrantIncomeDelete() {
    const recordId = parseInt($(this).closest("tr").attr("data-grantincomeid"));
    const params = {
        data: recordId,
        successMsg: "Grant Income Item Removed.",
        url: "/Course/CourseGrantIncomeRemove"
    };

    dataaccess.post(params).done(function (results) {
        getCourseGrantIncomeList("grantIncomeWrapper")
    });
}

function evtbtnCourseGrantIncomeUpdateSubmit() {
    const $form = $(this).closest("form");
    if (validateAmount() && $form.valid()) {
        const $btnSubmit = $("#CourseGrantIncomeModal button[type=submit]");
        $btnSubmit.prop("disabled", true);

        const params = {
            "contentType": dataaccess.contentType.APPLICATION_X_WWW_FORM_URLENCODED,
            "data": $form.serialize(),
            "url": $form.attr("action"),
            "successMsg": "Grant Income has been saved."
        };

        dataaccess.post(params).done(function (result) {
            $("#CourseGrantIncomeModal").modal("hide");
        }).always(function () {
            $btnSubmit.prop("disabled", false);
            getCourseGrantIncomeList("grantIncomeWrapper");
        });
    }
};

function validateAmount() {
    const amount = parseInt($("#Amount").val());
    const inKindTypeId = parseInt($("#InKindTypeId").val());
    if (amount === 0 && inKindTypeId == 0) {
        $("#amountValidationSpan").show();
        $("#inKindTypeIdValidationSpan").show();
        return false;
    }
    return true
}

export const courseFinancials = {
    init: init
};